export enum RoundIndexes {
  midpoint = 3,
}
